import type { ReactNode } from 'react';

interface PriceSummaryRowsProps {
  productAmount: number;
  deliveryFee: number;
  discountAmount: number;
  finalAmount: number;
  deliveryFeeTooltip?: ReactNode;
  discountTooltip?: ReactNode;
}

export const PriceSummaryRows = ({
  productAmount,
  deliveryFee,
  discountAmount,
  finalAmount,
  deliveryFeeTooltip,
  discountTooltip,
}: PriceSummaryRowsProps) => {
  return (
    <div className="flex flex-col gap-12">
      <div className="flex items-center justify-between px-4 font-500 text-Gray-600 typo-body2">
        <span>선택 상품 금액</span>
        <span>{productAmount.toLocaleString()}원</span>
      </div>
      <div className="flex items-center justify-between px-4 font-500 text-Gray-600 typo-body2">
        <span className="flex items-center gap-4">
          총 배송비
          {deliveryFeeTooltip}
        </span>
        <span>{deliveryFee.toLocaleString()}원</span>
      </div>
      <div className="flex items-center justify-between px-4 font-500 typo-body2">
        <span className="flex items-center gap-4 text-Gray-600">
          예상 할인 금액
          {discountTooltip}
        </span>
        <span className="text-R-400">
          {discountAmount > 0 && '-'}
          {discountAmount.toLocaleString()}원
        </span>
      </div>
      <div className="flex items-center justify-between px-4 font-700 text-Gray-900 typo-body2">
        <span>예상 결제 금액</span>
        <span>{finalAmount.toLocaleString()}원</span>
      </div>
    </div>
  );
};
